export class WidgetRepo {
  async sendWidgetEvent(
    event: string,
    env: string,
    widgetId: string,
    eventProperties?: {},
  ) {
    fetch(`${env}/publicApiFunctions-sendWidgetEvent`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        widgetId: widgetId,
        event,
        eventProperties,
      }),
    }).then();
  }
}
